module.exports = {
  expectingParentEvents: {
    SetADueDate: {
      code: 'SetADueDate',
      events: {
        PageLoad: {
          description: 'Triggered when the "Set a due date" page viewed.',
          eventHub: {
            code: 'OnLoad',
            action: 'SetADueDate_Page loaded'
          }
        },
        MonthClick: {
          description: 'Triggered when the "Month" field is clicked.',
          eventHub: {
            code: 'OnClickMonth',
            action: 'SetADueDate_Clicked Month'
          }
        },
        YearClick: {
          description: 'Triggered when the "Year" field is clicked.',
          eventHub: {
            code: 'OnClickYear',
            action: 'SetADueDate_Clicked Year'
          }
        },
        PrimaryCtaClick: {
          description: 'Triggered when the primary CTA button is clicked.',
          eventHub: {
            code: 'OnClickPrimaryCta',
            action: 'SetADueDate_Clicked Set due date'
          }
        },
        SecondaryCtaClick: {
          description: 'Triggered when the secondary CTA button is clicked.',
          eventHub: {
            code: 'OnClickSecondaryCta',
            action: 'SetADueDate_Clicked Explore dashboard'
          }
        },
        BackClick: {
          description: 'Triggered when the back button is clicked.',
          eventHub: {
            code: 'OnClickBack',
            action: 'SetADueDate_Clicked back arrow'
          }
        }
      }
    },
    ReviewPage: {
      code: 'ReviewPage',
      events: {
        EditDueDateClick: {
          description: 'Triggered when a "Edit" due date button is clicked on the prenatal onboarding review page.',
          eventHub: {
            code: 'OnClickEditDueDate',
            action: 'ReviewPage_Clicked Edit due date'
          }
        }
      }
    },
    SuccessPage: {
      code: 'SuccessPage',
      events: {
        SetDueDateClick: {
          description: 'Triggered when the "Set a due date" button is clicked on the prenatal onboarding success page.',
          eventHub: {
            code: 'OnClickSetDueDate',
            action: 'SuccessPage_Clicked Set a due date'
          }
        }
      }
    }
  }
};
